import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import './index.css';

// 为头部添加缓存控制
const meta = document.createElement('meta');
meta.httpEquiv = 'Cache-Control';
meta.content = 'no-cache, no-store, must-revalidate';
document.head.appendChild(meta);

const pragma = document.createElement('meta');
pragma.httpEquiv = 'Pragma';
pragma.content = 'no-cache';
document.head.appendChild(pragma);

const expires = document.createElement('meta');
expires.httpEquiv = 'Expires';
expires.content = '0';
document.head.appendChild(expires);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

